import { cva } from "class-variance-authority";

export const cardCarouselVariants = cva("relative w-full overflow-hidden");
